// Source: https://stackoverflow.com/a/62596701
export default function recoverHardRefresh(registration) {
  // There's an active SW, but no controller for this tab.
  if (registration?.active && !navigator.serviceWorker.controller) {
    console.log("Detected hard refresh or similar, reloading")
    // Perform a soft reload to load everything from the SW and get
    // a consistent set of resources.
    window.location.reload();
  }
}